/* eslint-disable react/sort-comp,import/prefer-default-export,no-shadow, no-loop-func,
 no-nested-ternary */

/* @flow */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import type { Connector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import './../../../../styles_common/questionnaire_form.scss';
import * as notify from '../../../../../../utils/notify';
import {
  Context as ContextType,
  QuestionnaireExperience as QuestionnaireExperienceContext,
  Reducer,
  Dispatch,
} from '../../../../../../types/index';
import Button from '../../../../../../components/Button/index';
import TextInput from '../../../../../../components/TextInput/index';
import TextArea from '../../../../../../components/TextArea/index.uncontrolled';
import Title from '../../../../../../components/Title/index';
import ConfirmCheckbox from '../../../../../../components/ConfirmCheckbox/index';
import MultiSelect from '../../../../../../components/MultiSelect/index';
import Alert from '../../../../../../components/Alert/index';
import Paragraph from '../../../../../../components/Paragraph/index';
import FundTool from '../../../../../../components/FundTool/index';
import Tooltip from '../../../../../../components/Tooltip/index';
import IqID from '../../../../../../utils/constants/questionnaire/identifiers.import';
import { saveGeneralInformation, saveSingleGeneralInfoField } from '../../../../util';
import DateTimeZone from '../../../../../../utils/date-time-zone';

type Props = {
  context: ContextType,
  questionnaireContext: QuestionnaireExperienceContext,
};

const initialState = {
  nameDissolution: {
    value: '',
    valid: true,
    isRequired: false,
    errorMessage: '',
    validators: ['required'],
  },
  titleDissolution: {
    value: '',
    valid: true,
    isRequired: false,
    errorMessage: '',
    validators: ['required'],
  },
}

export class DissolutionForm extends PureComponent {
  props: Props;
  state = initialState;
  static defaultProps: {
    history: {},
    context: {},
  };

  componentDidMount() {
    notify.hideNotification();
    this.checkPreviousInformation();
  }

  checkPreviousInformation = () => {
    const { questionnaireContext } = this.props;

    const generalInfo = questionnaireContext.investorFund &&  questionnaireContext.investorFund.generalInfo;

    if (
      generalInfo &&
      generalInfo._id
    ) {
      this.setState({
        nameDissolution: {
          ...this.state.nameDissolution,
          value: generalInfo.nameDissolution || '',
        },
        titleDissolution: {
          ...this.state.titleDissolution,
          value: generalInfo.titleDissolution || '',
        },
      },
      () => {
        sessionStorage.setItem(
          'generalInfo',
          JSON.stringify(generalInfo)
        );
      });
    }

  };

  handleTextInputChange = (event) => {
    
    event.preventDefault();
    this.setState({
      ...this.state,
      [event.target.name]: {
        ...this.state[event.target.name],
        value: event.target.value,
      },
    });
  };

  handleSaveFieldOnBlur = (event) => {
    event.preventDefault();
    if (sessionStorage.getItem('generalInfo')) {
      const info = JSON.parse(sessionStorage.getItem('generalInfo'));
      info[event.target.name] = event.target.value;
      sessionStorage.setItem('generalInfo', JSON.stringify(info));
    }
    
  };

  handlerFormSubmit = (event) => {
    const { questionnaireContext } = this.props;
    
    event.preventDefault();
    this.saveAllFields();
    const nextStep = questionnaireContext.currentStep + 1;
    this.props.handleRedirect(event, nextStep);
  };

  backStep = (e) => {
    const { questionnaireContext } = this.props;
    this.props.handleRedirect(e, questionnaireContext.currentStep - 1);
  };

  saveAllFields = () => {
    const { questionnaireContext } = this.props;
    const generalInfo = questionnaireContext.investorFund &&  questionnaireContext.investorFund.generalInfo;

    const consentOfDissolutionQuestion = this.parseQuestionDataFromId(IqID.id_consent_to_dissolution); 

    const consentYesAnswered = consentOfDissolutionQuestion && consentOfDissolutionQuestion.answer === 'Yes';

    if (!questionnaireContext.savingGeneralInformation) {
      const payload = {
        ...generalInfo,
        nameDissolution: consentYesAnswered ? '' : this.state.nameDissolution.value,
        titleDissolution: consentYesAnswered ? '' : this.state.titleDissolution.value,
      };
      saveGeneralInformation(payload, this.props);
      }
  }

  parseCheckboxStateFromId = (_identifier) => {
    const { questionnaireContext } = this.props;
    const questions =
      questionnaireContext.investorFund.questionnaire.questions || [];
    if (questions && questions.length) {
      const targetQuestion = questions.find(
        (_q) => _q.descriptionIdentifier === _identifier
      );
      if (targetQuestion) {
        return [
          targetQuestion.answer === 'Yes',
          targetQuestion.answer === 'No',
        ];
      }
      return [false, false];
    }
    return [false, false];
  };
  parseMultiSelectStateFromId = (_identifier) => {
    const { questionnaireContext } = this.props;
    const questions =
      questionnaireContext.investorFund.questionnaire.questions || [];
    if (questions && questions.length) {
      const targetQuestion = questions.find(
        (_q) => _q.descriptionIdentifier === _identifier
      );
      if (targetQuestion) {
        return targetQuestion.answer === 'Yes';
      }
      return false;
    }
    return false;
  };
  parseQuestionDataFromId = (_identifier) => {
    const { questionnaireContext } = this.props;
    let targetQuestion = null;
    const questions =
      questionnaireContext.investorFund.questionnaire.questions || [];
    if (questions && questions.length) {
      targetQuestion = questions.find(
        (_q) => _q.descriptionIdentifier === _identifier
      );
      if (targetQuestion) {
        return targetQuestion;
      }
    }
    return targetQuestion;
  };
  handlerConfirm = (event) => {
    event.preventDefault();
    const answer = event.target.nextSibling.innerHTML;
    const descriptionIdentifier = event.target.closest('div').parentElement.parentElement.id;
    this.props.updateMultiSelectFormAnswer(descriptionIdentifier, answer);
  };
  orQuestionSelected = (_checked, _identifier, _targetSection) => {
    const {
      questionnaireContext: { currentVersionQuestions },
    } = this.props;
    const targetQuestionsLookup = currentVersionQuestions[_targetSection];
    for (let i = 0; i < targetQuestionsLookup.length; i += 1) {
      const item = targetQuestionsLookup[i];
      // if the item was selected other than _or it needs to be reverted
      if (
        item.id !== _identifier &&
        this.parseMultiSelectStateFromId(item.id)
      ) {
        // right now this is saving one by one . But ideally we should do bulks updates or at least Promise all
        const answer = 'No';
        const descriptionIdentifier = item.id;

        this.props.updateMultiSelectFormAnswer(descriptionIdentifier, answer);
      }
    }
  };

  distributionElectionHandler = () => {
    const {
      questionnaireContext,
      questionnaireContext: {
        multiSelectFormMetadata: { disabled: disabledList }, x
      },
    } = this.props;
    const distributionElection = questionnaireContext.currentVersionQuestions.distributionElections;

     const results = [];
     if (distributionElection) {
      for (
        let i = 0;
        i < distributionElection.length;
        i += 1
      ) {
        results.push({
          id: distributionElection[i].id,
          displayName: ReactHtmlParser(
            distributionElection[i].displayName
          ),
          name: distributionElection[i].name,
          identifier: distributionElection[i].identifier,
          isSelected: this.parseMultiSelectStateFromId(
            distributionElection[i].id
          ),
          helpText: distributionElection[i].helpText,
          showHelp: distributionElection[i].showHelp,
          disabled: disabledList.includes(distributionElection[i].id),
           // this part should come from top part lists
        });
      }
      return results;
    }  
  };

  regularQuestionSelected = (_checked, _identifier, _targetSection) => {
    const {
      questionnaireContext: { currentVersionQuestions },
    } = this.props;
    const targetQuestionsLookup = currentVersionQuestions[_targetSection];
    for (let i = 0; i < targetQuestionsLookup.length; i += 1) {
      const item = targetQuestionsLookup[i];
      // if the item was selected other than _or it needs to be reverted
      if (
        item.id.includes('_or') &&
        this.parseMultiSelectStateFromId(item.id)
      ) {
        // can be simplified with the orQuestionSelected on top look for better naming
        const answer = 'No';
        const descriptionIdentifier = item.id;
        this.props.updateMultiSelectFormAnswer(descriptionIdentifier, answer);
      }
    }
  };
  // send the belonging section here
  handlerMultiSelect = (event, _targetSection) => {
    const answer = event.target.checked ? 'Yes' : 'No';
    const descriptionIdentifier = event.target.id;

    if (event.target.id.includes('_or')) {
      this.orQuestionSelected(
        event.target.checked,
        event.target.id,
        _targetSection
      );
    } else {
      // if any other is marked verify that or question is not selected from the targetSection
      this.regularQuestionSelected(
        event.target.checked,
        event.target.id,
        _targetSection
      );
    }
    this.props.updateMultiSelectFormAnswer(descriptionIdentifier, answer);
  };

  // send the belonging section here
  handlerSingleSelect = (event, _targetSection) => {
    const answer = event.target.checked ? 'Yes' : 'No';
    const descriptionIdentifier = event.target.id;

    this.orQuestionSelected(
      event.target.checked,
      event.target.id,
      _targetSection
    );
    this.props.updateMultiSelectFormAnswer(descriptionIdentifier, answer);
  };

  // This one should be handled as part of the optional questions set at the
  checkBadActorQuestionAbility = (identifier) => {
    if (identifier === IqID.id_investor_status_5_f) {
      if (
        !this.parseMultiSelectStateFromId(IqID.id_investor_status_5_a) &&
        !this.parseMultiSelectStateFromId(IqID.id_investor_status_5_b) &&
        !this.parseMultiSelectStateFromId(IqID.id_investor_status_5_c) &&
        !this.parseMultiSelectStateFromId(IqID.id_investor_status_5_d) &&
        !this.parseMultiSelectStateFromId(IqID.id_investor_status_5_e)
      ) {
        return false; // to show return true;
      }
    }
    return true;
  };

   handleTextInputBlur = (event, currentValue) => {
    event.preventDefault();
    const hasId = [
      'id_investor_status_7_tcg_o',
      'id_investor_status_7_tcg_m',
    ]
    
    const answer = event.target.value;
    const descriptionIdentifier = event.target.id;
    const tcgCross = hasId.includes(descriptionIdentifier)
   
    const current = this.parseQuestionDataFromId(descriptionIdentifier);
    if (!current || current.answer !== currentValue && !tcgCross) {
      this.props.updateMultiSelectFormAnswer(descriptionIdentifier, answer);
    }
    if ((!current || current.answer) && tcgCross) {
     this.props.updateMultiSelectFormAnswer(descriptionIdentifier, 'Yes', answer);
      
    }
    
  };

  handleCapitalChange = (maskedValue, floatValue, event) => {
    event.preventDefault();
    this.setState(
      {
        ...this.state,
        capitalCommitment: {
          ...this.state.capitalCommitment,
          value: floatValue,
        },
      },
      () => {
        if (sessionStorage.getItem('generalInfo')) {
          const info = JSON.parse(sessionStorage.getItem('generalInfo'));
          info.capitalCommitment = floatValue;
          sessionStorage.setItem('generalInfo', JSON.stringify(info));
        }
      }
    );
  };

  renderTextInput = (
      name,
      id,
      type,
      value,
      displayName,
      isRequired,
      size,
      hasError,
      errorMessage,
      changeHandler,
      helpText,
      disabled,
    ) => {
      const inputDataTemp = {
        name,
        id,
        displayName,
        isRequired,
        size,
        hasError,
        type,
        errorMessage,
        value,
        wrapperClass: '',
        showHelp: helpText && helpText !== '',
        helpText,
        disabled,
      };
      return (
        <TextInput
          inputData={inputDataTemp}
          onChangeHandler={changeHandler}
          onBlurHandler={this.handleSaveFieldOnBlur}
        />
      );
    };

  renderConfirm = (
    id,
    title,
    isSelected,
    name,
    size,
    helpText,
    changeHandler,
    isDisabled
  ) => {
    //eslint-disable-next-line
    if (!isDisabled) isDisabled = [false, false];
    const inputDataTemp = {
      id,
      title,
      isSelected,
      name,
      size,
      showHelp: helpText && helpText !== '',
      helpText,
      isDisabled,
    };
    return (
      <ConfirmCheckbox data={inputDataTemp} onChangeHandler={changeHandler} />
    );
  };

  render() {
    const {
      context,
      questionnaireContext,
    } = this.props;


    const lpName = questionnaireContext.investorFund && questionnaireContext.investorFund.generalInfo &&
      questionnaireContext.investorFund.generalInfo.name || '';

    const consentOfDissolutionQuestion = this.parseQuestionDataFromId(IqID.id_consent_to_dissolution); 
    
    const generalInfo = questionnaireContext.investorFund &&  questionnaireContext.investorFund.generalInfo;

    return (
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="row ">
              <div className='' >
                  <div className="row content-bg main-content-area clearfix container-content-padding" style={{ margin: '20px', paddingBottom: '5rem', marginTop: '0' }}>
                    <Title text={questionnaireContext.fund.fundLegalName} />
                    <Title text={'Waiver and Consent to Dissolution'} />
                    <br />
                    <div className="paragraph-container" style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
                        <p>
                         With regard to the Amendment to the Amended and Restated Limited Partnership 
                         Agreement of UNION Labs Ventures II, L.P., Waiver and Consent to Dissolution, 
                         please review the LP Name you’ve entered for your commitment to Union Peak Ventures I, L.P.:
                        </p>
                     </div>
                     <div className="">
                      {lpName && <Title text={lpName} />}

                        {this.renderConfirm(
                          [
                            `${IqID.id_consent_to_dissolution}_yes`,
                            `${IqID.id_consent_to_dissolution}_no`,
                            IqID.id_consent_to_dissolution,
                          ],
                          'Is this the same investing entity that will sign the Amendment to the Amended and Restated Limited Partnership Agreement of UNION Labs Ventures II, L.P., Waiver and Consent to Dissolution? For clarity, is the individual or entity through which you invested in UNION Labs Ventures II, L.P. the same individual or entity that is investing in Union Peak Ventures I, L.P.?',
                          this.parseCheckboxStateFromId(IqID.id_consent_to_dissolution),
                          'consent_to_dissolution_checkbox',
                          '',
                          '',
                          this.handlerConfirm
                        )}
                      </div>

                   { consentOfDissolutionQuestion && consentOfDissolutionQuestion.answer === 'No' ? 
                    
                    <>
                      <div className="row" style={{display: 'flex', flexDirection: 'column'}}>
                          {this.renderTextInput(
                            'nameDissolution',
                            'nameDissolution',
                            'text',
                             this.state.nameDissolution.value,
                            'Name of Limited Partner',
                            false,
                            'medium',
                            !this.state.nameDissolution.valid,
                            this.state.nameDissolution.errorMessage,
                            this.handleTextInputChange,
                          )}
                          <span style={{ marginLeft: '1.8rem', width: '60%', fontStyle: 'italic' }}>
                            Print name of Limited Partner exactly as written on the Limited Partner’s signature 
                            page to the Partnership Agreement of UNION Labs Ventures II, L.P.
                          </span>                          
                      </div>
                      <div className="row" style={{display: 'flex', flexDirection: 'column'}}>
                        {this.renderTextInput(
                          'titleDissolution',
                          'titleDissolution',
                          'text',
                          this.state.titleDissolution.value,
                          'Title',
                          false,
                          'medium',
                          !this.state.titleDissolution.valid,
                          this.state.titleDissolution.errorMessage,
                          this.handleTextInputChange,
                        )}
                        <span style={{ marginLeft: '1.8rem', width: '60%', fontStyle: 'italic' }}>
                          Please enter the capacity in which the signatory will be signing on behalf of the investing entity above (e.g., Member, Manager, Trustee, Chief Executive Officer, President, etc.)
                        </span>
                      </div>
                    </>
                    : null}

                    </div>
                <br />

                <div className="" style={{ position: 'relative', margin: '20px', marginBottom: '15rem' }}>
                  <div className="back-btn">
                    <Button
                      inputData={{
                        id: 'back-btn',
                        displayName: 'Back',
                        type: 'button',
                      }}
                      clickHandler={this.backStep}
                    />
                  </div>
                  <div className="next-btn">
                    <Button
                      inputData={{
                        id: 'next-btn',
                        displayName: 'Next',
                        type: 'button',
                      }}
                      clickHandler={this.handlerFormSubmit}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    )
  }
}

const mapStateToProps = (state: Reducer) => ({
  context: state.context,
  questionnaireContext: state.questionnaireExperience,
});
const connector: Connector<{}, Props> = connect(
  mapStateToProps,
  (dispatch: Dispatch) => ({})
);

export default connector(DissolutionForm);
